import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from '../../utils/currency';
import { isUKOrIreland } from '../../utils/countries';

import './GuidePrice.css';

/**
 * GuidePrice - Displays guide price for UK/Ireland auctions
 * Guide prices are common in UK/Ireland property auctions as an indication
 * of the expected sale price.
 */
const GuidePrice = ({ guidePrice, countryId, currency }) => {
    // Only show for UK/Ireland auctions with a guide price
    if (!guidePrice || !isUKOrIreland(countryId)) {
        return null;
    }

    const formattedPrice = formatPrice(guidePrice, countryId, currency);

    if (!formattedPrice) {
        return null;
    }

    return (
        <div className="al-guide-price">
            <span className="al-guide-price-label">Guide Price</span>
            <span className="al-guide-price-value">{formattedPrice}</span>
        </div>
    );
};

GuidePrice.propTypes = {
    guidePrice: PropTypes.number,
    countryId: PropTypes.number,
    currency: PropTypes.string
};

export default GuidePrice;
